import AWS from "aws-sdk";

const s3 = new AWS.S3({
  region: "us-east-2", // ✅ change if different
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  }
});

export const uploadToS3 = async (file) => {
  const cleanFileName = file.name.toLowerCase().replace(/[^a-z0-9.\-_]/g, "_");

  const params = {
    Bucket: "rcsdatastorage",
    Key: `vendors/${Date.now()}-${cleanFileName}`,
    Body: file,
    ContentType: file.type
  };

  try {
    const result = await s3.upload(params).promise();
    console.log("✅ Upload success:", result);
    return result.Location;
  } catch (err) {
    console.error("❌ Upload failed (but file may still exist):", err);
    throw err;
  }
};
